import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  arrow: {
    zIndex: '0',
    position: 'absolute',
    top: '50%',
    margin: '0 3px',
    borderRadius: '50%',
    boxShadow: '0px 0px 5px -2px black',
    backgroundColor: 'white',
    color: theme.palette.primary.main,

    '&:hover': {
      backgroundColor: 'white !important'
    },
    '&:disabled': {
      backgroundColor: 'white !important',
      opacity: 0.7
    }
  },
  rightArrow: { right: '-20px' },
  leftArrow: { left: '-20px' }
}))

export default useStyles
